/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
import Group from "vux/src/components/group/index.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import CellBox from "vux/src/components/cell-box/index.vue"; // this line is trasformed by vux-loader
import XInput from "vux/src/components/x-input/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import { apiordereeceipt, apiproject, apiordereeceiptNoLogin } from '@/api';
import ExtField from '@/components/ExtField';
import ImgUpload from '@/components/ImgUpload';
import ServiceAmountTable from './ServiceAmountTable';
import WriteExecute from './WriteExecute';
export default {
  components: {
    Popup: Popup,
    ViewBox: ViewBox,
    PopupPicker: PopupPicker,
    Group: Group,
    XButton: XButton,
    Cell: Cell,
    CellBox: CellBox,
    XInput: XInput,
    ExtField: ExtField,
    ServiceAmountTable: ServiceAmountTable,
    WriteExecute: WriteExecute,
    ImgUpload: ImgUpload
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    oid: {
      type: String
    }
  },
  data: function data() {
    return {
      isShowExecute: 0,
      loading: false,
      showContent1: true,
      showContent2: true,
      showContent3: true,
      currValue: this.value,
      ReceiptExtField: [],
      nodeTmplMap: {},
      totalTime: '',
      service: {},
      sparePartList: [],
      moneyItemList: [],
      imageDescriList: [],
      editShow: false,
      writeShow: false,
      wait: 60,
      count: 0,
      clear: '',
      customFields: [],
      from: {
        pics: [],
        code: '',
        signImg: ''
      },
      template: {
        is_receipt: 1
      },
      orderInfo: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['user'])), {}, {
    epId: function epId() {
      var normalUrl = location.href.includes('children/account');
      try {
        var code = normalUrl ? window.location.href.match(/\w+(?=\/index)/g)[0] : window.location.href.match(/zhongyifu\.cn\/(\w+)/) ? window.location.href.match(/zhongyifu\.cn\/(\w+)/)[1] : '';
        return this.user.epCode || code;
      } catch (error) {
        console.log('AutoConsole: epId -> error', error);
        return this.user.epCode || '';
      }
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions('globalStore', ['_ApiSession'])), {}, {
    reload: function reload() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 按顺序执行
                if (!_this.epId) {
                  _this.$vux.toast.text(i18n.tc("629"));
                }
                _context.next = 3;
                return apiordereeceiptNoLogin({
                  oid: _this.oid,
                  epId: _this.epId
                });
              case 3:
                _context.next = 5;
                return _this._ApiSession();
              case 5:
                _context.next = 7;
                return apiordereeceipt({
                  oid: _this.oid
                }).then(function (res) {
                  if (res.success) {
                    _this.nodeTmplMap = res.data.nodeTmplMap;
                    _this.totalTime = res.data.total_time;
                    _this.ReceiptExtField = res.data.receipt_list;
                    _this.imageDescriList = res.data.image_descri_list;
                    _this.service = res.data.settleMap || {};
                    //   this.sparePartList = res.data.settleMap.sparepart_list
                    //   this.moneyItemList = res.data.settleMap.moneyItem_list
                  }
                });
              case 7:
                _context.next = 9;
                return apiproject({
                  oid: _this.oid
                }).then(function (res1) {
                  if (res1.success) {
                    _this.orderInfo = res1.data.orderMap;
                    _this.template = res1.data.orderTmpl;
                  }
                });
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 提交回执
    uploadSign: function uploadSign() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var sign, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                sign = _this2.service.sign;
                if (sign) {
                  _context2.next = 4;
                  break;
                }
                _this2.$vux.toast.text(i18n.tc("529"));
                return _context2.abrupt("return", false);
              case 4:
                _this2.loading = true;
                _this2.$vux.loading.show({
                  text: i18n.tc("616")
                });
                _context2.next = 8;
                return apiordereeceipt({
                  id: _this2.service.id,
                  sign: sign
                }, 'put');
              case 8:
                res = _context2.sent;
                setTimeout(function () {
                  _this2.loading = false;
                  _this2.$vux.loading.hide();
                }, 300);
                if (!res.success) {
                  _context2.next = 18;
                  break;
                }
                _this2.$vux.toast.text(i18n.tc("631"));
                _context2.next = 14;
                return apiordereeceiptNoLogin({
                  oid: _this2.oid,
                  epId: _this2.epId
                });
              case 14:
                _context2.next = 16;
                return _this2._ApiSession();
              case 16:
                _context2.next = 19;
                break;
              case 18:
                _this2.$vux.toast.text(i18n.tc("630"));
              case 19:
                _this2.$emit('on-success');
                _this2.writeShow = false;
              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }),
  created: function created() {
    this.reload();
  }
};